import { render } from "./SelectedOrder.vue?vue&type=template&id=a10766f6&scoped=true"
import script from "./SelectedOrder.vue?vue&type=script&lang=js"
export * from "./SelectedOrder.vue?vue&type=script&lang=js"

import "./SelectedOrder.vue?vue&type=style&index=0&id=a10766f6&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a10766f6"]])

export default __exports__